import { mat4 } from 'gl-matrix';

export class AnimationFrame {
  public index!: number;
  public timeStep: number;
  public matrix: mat4;
  public worldMatrix?: mat4;
  public jointMatrix!: mat4;
  public invBindMatrix!: mat4;
  public interpolation: string;
  public nextFrame?: AnimationFrame;
  public previousFrame?: AnimationFrame;

  constructor(timeStep: number, matrix: mat4, interpolation: string) {
    this.timeStep = timeStep;
    this.matrix = matrix;
    this.interpolation = interpolation;
  }
}
